export const isDev = import.meta.env.DEV;

const storagePrefix = __APP_NAME__;

// During dev, prefix so it doesn't collide with other dev projects. Otherwise, just 'debug' is easier.
export const debugEnabled = localStorage.getItem(isDev ? `${storagePrefix}.debug` : 'debug') === 'true';

export const isDevOrDebug = isDev || debugEnabled;
